// import Vue from 'vue'

// Vue.filter('fixed', function (value) {
//   if (!value) return ''
//   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
// })

// Vue.filter('dateonly', function (value) {
//   if (!value) return ''
//   return Vue.moment(value).format('YYYY-MM-DD')
// })

// Vue.filter('dateonly', function (value) {
//   if (!value) return ''
//   return Vue.moment(value).format('YYYY-MM-DD')
// })
export const currency = value => {
  if (!value) return null
  let x = parseFloat(value).toFixed(0)
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' SEK'
}



// WEBPACK FOOTER //
// ./src/helpers/customfilters.js